// K & K Associates — firm profile data (source of truth: company profile PDF).
// Reused across Home (Notable Clients) and the Company Profile page.

export const firmOverview =
  "A distinguished full-service law firm headquartered in New Delhi, committed to delivering ethical, strategic, and result-oriented legal counsel across litigation, arbitration, and corporate advisory. Established in 2006, K & K Associates has grown into a trusted partner for leading Indian and multinational corporations, government bodies, and individual clients across diverse practice areas.";

export const firmStats = [
  { num: "2006", label: "Year Established" },
  { num: "35+", label: "Combined Years at the Bar" },
  { num: "500+", label: "Reported Decisions" },
  { num: "25+", label: "Juniors Mentored" },
];

export const trackRecord = [
  { num: "26", label: "Reported Judgments" },
  { num: "18", label: "Arbitral Awards" },
  { num: "141", label: "Other Favourable Decisions" },
];

export const vision =
  "To be a trusted legal service provider delivering ethical and client-centric legal solutions while contributing meaningfully to the growth of the legal and business ecosystem.";

export const mission =
  "To provide practical, strategic, and result-oriented legal counsel with the highest standards of professionalism, integrity, and excellence. The firm is committed to understanding client needs, building lasting relationships, and delivering timely and effective legal services across diverse practice areas.";

export const coreValues = [
  { title: "Integrity", body: "Upholding honesty, transparency and ethical conduct in every engagement. Our reputation is founded on the trust clients and courts place in our counsel — a trust never taken lightly." },
  { title: "Excellence", body: "Striving for the highest quality in legal advisory and representation. Every pleading, opinion and argument is prepared with meticulous attention to detail." },
  { title: "Client Commitment", body: "Prioritising client interests through responsive, solution-driven service. We treat every client's matter as our own and remain accessible throughout the engagement." },
  { title: "Collaboration", body: "Fostering teamwork, inclusivity and knowledge-sharing within the firm. The collective wisdom of partners, associates and juniors is brought to bear on every complex matter." },
  { title: "Innovation", body: "Adapting to evolving legal and business environments with forward-thinking approaches — from paperless operations to custom case-management software." },
  { title: "Confidentiality & Trust", body: "Maintaining the utmost discretion and professionalism in handling client matters. Attorney-client privilege is sacred, and we uphold it without exception." },
];

export const partners = [
  {
    name: "Mr. Manav Kumar",
    role: "Founder",
    experience: "21+ years at the Bar",
    image: "/profile/partner-manav-kumar.jpeg",
    education: [
      "St. Columba's School, Delhi",
      "BA LLB (Hons.) — Amity Law School, GGSIPU, Delhi",
      "Diploma in Forensic Science",
    ],
    bio: [
      "Founding partner of K & K Associates, Mr. Manav Kumar brings over 21 years of distinguished legal experience to the firm. Upon graduating in 2004, he apprenticed under Mr. Man Mohan Singh — eminent IP Attorney and former Judge of the Delhi High Court — gaining early exposure to complex litigation before the District Courts and the High Court. This mentorship laid a robust foundation for his independent practice, which commenced in 2006.",
      "Since then, he has handled intricate matters across a wide hierarchy of judicial authorities, functioning both as external counsel and organisational directionalist in complex disputes. Beyond the courtroom, his practice extends to pre-litigation counselling, legal opinions and out-of-court dispute resolution — adding stability and strategic depth to client outcomes. He has distinguished himself as a formidable arguing counsel and a trusted advisor who helps clients navigate complex legal and business environments with clarity and confidence.",
    ],
  },
  {
    name: "Mr. Vatsal Kumar",
    role: "Partner",
    experience: "14 years at the Bar",
    image: "/profile/partner-vatsal-kumar.jpeg",
    education: [
      "St. Columba's School, Delhi",
      "BA LLB (Hons.) — Vivekananda Institute of Professional Studies, GGSIPU, Delhi",
      "Masters in Business Laws (MBL) — National Law School of India University, Bengaluru",
      "LLM in International Dispute Resolution — Queen Mary University, London",
    ],
    bio: [
      "Mr. Vatsal Kumar joined K & K Associates as Partner in 2017, bringing an exceptional academic pedigree and 14 years of comprehensive legal experience. His LLM in International Dispute Resolution from Queen Mary University, London — one of the world's foremost institutions for dispute resolution studies — complements a Masters in Business Laws from the National Law School of India University, Bengaluru.",
      "He served with Mr. Sandeep Sharma, Senior Advocate, Delhi High Court, between 2012 and 2016, gaining hands-on experience before the Supreme Court of India, the Delhi High Court, District Courts, the Debt Recovery Tribunal, the Central Administrative Tribunal, Consumer Fora and in domestic arbitration proceedings. He appears and advises in matters before the Hon'ble Supreme Court, maintains an extensive Delhi High Court practice, and represents parties in domestic and international arbitration.",
    ],
  },
];

export const journey = [
  { year: "2004", text: "Mr. Manav Kumar completes BA LLB (Hons.) and begins his legal career, apprenticing under a former Judge of the Delhi High Court." },
  { year: "2006", text: "K & K Associates is established as a sole proprietorship firm by Mr. Manav Kumar." },
  { year: "2012–2016", text: "Mr. Vatsal Kumar builds his legal expertise with a Senior Advocate at the Delhi High Court." },
  { year: "2017", text: "The firm transforms into a partnership with Mr. Vatsal Kumar joining as Partner." },
  { year: "Today", text: "Over 19 years of practice, 25+ juniors mentored, hundreds of cases handled, serving Indian and multinational clients across India." },
];

export const litigationAreas = [
  "Intellectual Property", "Consumer Protection", "Arbitration", "Labour, Industrial & Employment",
  "Civil", "Real Estate & Construction", "Debt Recovery", "Motor Accident Claims",
  "Electricity", "Banking & Finance", "Insurance Claims", "White Collar Crimes",
  "Companies Act", "Negotiable Instruments", "Lease & Tenancy", "Guardianship & Child Custody",
  "Succession", "Matrimonial",
];

export const nonLitigationServices = [
  "Contract Drafting & Vetting", "IP Registration", "Real Estate Documentation",
  "Legal Opinions", "Corporate Advisory", "Mergers & Acquisitions",
  "Startup Legal Advisory", "Legal Notices & Communications", "Policy Drafting",
];

export const forums = {
  primary: [
    "Supreme Court of India", "Delhi High Court", "Delhi District Courts", "Consumer Courts",
    "Central Administrative Tribunal (CAT)", "Labour Courts & Tribunals",
    "Debt Recovery Tribunal & Appellate Body", "Arbitral Tribunals",
  ],
  panIndia: [
    "Delhi", "Punjab", "Haryana", "Uttar Pradesh", "Rajasthan", "West Bengal",
    "Assam (Guwahati)", "Bihar", "Maharashtra (Mumbai)", "Tamil Nadu (Chennai)",
    "Telangana (Hyderabad)", "Karnataka (Bengaluru)",
  ],
};

export const technology = [
  { title: "Paperless Operations", body: "A fully digital practice that reduces turnaround time and keeps every matter organised and retrievable." },
  { title: "Custom Case-Management Software", body: "Proprietary software with a dedicated client login, giving clients real-time visibility into their matters." },
  { title: "Daily Case Reporting", body: "Same-day reporting of court proceedings to clients via email — no client is ever left guessing." },
];

export const serviceCommitment = [
  { step: "Engage", body: "We understand your objectives, map the facts and assess exposure before advising on a path." },
  { step: "Act", body: "We execute the agreed strategy — pleadings, negotiations, filings and appearances — at partner level." },
  { step: "Advise", body: "We counsel continuously, flagging risks early and recommending the cheapest durable resolution." },
  { step: "Report", body: "We report progress the same day, keeping you informed at every stage of the engagement." },
];

export const memberships = [
  "International Trademark Association (INTA)",
  "Asian Patent Attorneys Association (APAA)",
  "ASSOCHAM & PHD Chamber of Commerce",
  "International Bar Association — Arbitration Day",
  "Millennial India International Chamber of Commerce & Industry (MIICCIA)",
  "FICCI Real Estate Conference",
  "Lex Witness Real Estate Summit",
  "MSME Startup Summit",
  "Nani Palkhivala Arbitration Centre — Arbitration Conference",
  "Society of Construction Law",
];

export const proBono = {
  panels: ["Supreme Court Legal Services Committee", "Delhi High Court Legal Services Committee"],
  areas: [
    "Civil and property disputes affecting marginalised individuals",
    "Consumer rights enforcement for low-income complainants",
    "Family law and custody matters involving vulnerable parties",
    "Labour rights for workers facing wrongful dismissal",
    "Criminal matters before legal aid panels",
  ],
};

// Notable clientele grouped by sector (text-based showcase).
export const clientSectors = [
  { sector: "Pharmaceuticals & Healthcare", clients: ["Abbott Healthcare", "Zydus Healthcare", "Glenmark Pharmaceuticals", "Macleods Pharmaceuticals", "Mankind Pharma", "Fortis Healthcare", "Agilus Diagnostics"] },
  { sector: "Consumer Goods & Lifestyle", clients: ["Puma", "Adidas", "Parle Agro", "Usha International", "Surya Roshini", "Vectus Industries", "Dolphin International"] },
  { sector: "Luxury & Automotive", clients: ["Burberry", "Jaguar", "BMW"] },
  { sector: "Technology & Telecom", clients: ["Tata Consultancy Services (TCS)", "SoftwareOne", "BlackBerry", "BTW India", "Idea Cellular", "Giesecke+Devrient"] },
  { sector: "Infrastructure & Construction", clients: ["Ocean Seven Buildtech", "Translite Scaffolding", "Cornish Aluminium", "Marcotrans Shipping", "PTC Financial Services", "Advanced Sports Technologies"] },
  { sector: "Government & PSUs", clients: ["Bureau of Indian Standards", "Export Inspection Council", "NHAI", "NBCC (India)", "EESL", "Dedicated Freight Corridor Corp.", "PEC Limited", "NewSpace India (NSIL)"] },
  { sector: "Transport & Infra PSUs", clients: ["IRCTC", "Northern Railways", "ITDC"] },
  { sector: "Academic Institutions", clients: ["Dr. B.R. Ambedkar National Law University, Sonipat", "Delhi Technological University", "Central University of Rajasthan"] },
];

// Flat list of marquee brand names for a compact logo-style strip.
export const marqueeClients = [
  "Puma", "Adidas", "BMW", "Jaguar", "Burberry", "BlackBerry", "Abbott", "Glenmark",
  "Macleods", "Mankind Pharma", "Fortis Healthcare", "Parle Agro", "Usha", "Surya Roshini",
  "TCS", "SoftwareOne", "NHAI", "NBCC", "EESL", "IRCTC", "ITDC", "Bureau of Indian Standards",
];

export const whyChooseUs = [
  { title: "Clients First", body: "A philosophy that, wherever possible, advises clients on how not to litigate — protecting time, money and reputation." },
  { title: "Proven Track Record", body: "Hundreds of reported and unreported cases, with favourable decisions across a remarkable range of practice areas." },
  { title: "International Perspective", body: "Cross-border capability anchored by an LLM in International Dispute Resolution from Queen Mary University, London." },
  { title: "Technology-Driven Service", body: "Paperless operations, proprietary case-management software and same-day case reporting." },
  { title: "Breadth of Practice", body: "18 litigation practice areas and 9 non-litigation services under one roof." },
  { title: "Social Responsibility", body: "Active pro bono engagement and panel membership with leading legal services committees." },
];


// Client logos extracted from the company-profile PDF (page 37 logo wall).
const CLIENT_LOGO_COUNT = 42;
export const clientLogos = Array.from({ length: CLIENT_LOGO_COUNT }, (_, i) =>
  `/profile/clients/client-${String(i + 1).padStart(2, "0")}.png`
);

// Infographics extracted from the company-profile PDF.
export const profileImages = {
  sectorRepresentation: "/profile/sector-representation.jpeg",
  disputeResolution: "/profile/dispute-resolution-approach.jpeg",
};
